/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preview/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Iframe from 'DesignSystem/Iframe/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Preview({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Preview"
  
}) {
let selectedConfigurationIdValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'configuration_id',
format: fromHelpers.leadsLink,
})
  return (<React.Fragment
>
<div
  data-testid="Preview.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Iframe
  viewPath={`${viewPath}/Iframe`}
 data="selected.configuration_id"
 format="helpers.js leadsLink"
 src={selectedConfigurationIdValueData}
/>
</div>
{children}
</React.Fragment>)
}